import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, message } from 'antd';
import {
  ALERT_TOP_PANEL_DETAIL_GS_QUERY,
  LANDING_FROM,
  RETURN_TO_PATH,
  LANDED_IN
} from '../constant';
import BreadCrumb from '../../../../components/BreadCrumb';
import SmartAssessmentTopPanel from '../../components/SmartAssessmentTopPanel';
import style from './index.scss';
import {
  fetchTypologiesActions,
  getAMLSCommonAlertDetails,
  putAMLSCommonAlertPartyUpdate
} from '../../../../redux/actions/common';
import { connect } from 'react-redux';

const PageHeader = ({
  alertId,
  alertDetails,
  isPrevention,
  fetchAlertDetails,
  updateUnifiedAlert,
  updateUnifiedAlertStatus = {},
  isFromCM,
  alertMetaSuffix,
  alertLevels,
  trmActionsData,
  fetchTypologiesActions
}) => {
  const { data = {}, isLoading } = updateUnifiedAlertStatus;
  const [disableSelectBox, setDisableSelectBox] = useState(false);

  useEffect(() => {
    if (alertId) fetchAlertDetails(alertId);

    if (isPrevention && !trmActionsData?.length) {
      fetchTypologiesActions();
    }
  }, [alertId, isPrevention]);

  useEffect(() => {
    if (!disableSelectBox || data === null) return;

    setDisableSelectBox(false);
    data?.status === 202
      ? message.success('Review feedback has been saved successfully')
      : message.error('Fail to update', data?.message);
  }, [data]);

  const onChangeAlertQuality = (alertQuality, sourceId) => {
    setDisableSelectBox(true);
    updateUnifiedAlert([{ alertId, sourceId, alertQuality }]);
  };

  return (
    <div className={style.navPanel}>
      <Row>
        {/* FIN-11542 closing sweep: flex="auto" + minWidth 0 so this Col fills
            the full Row width. Without it the Col shrink-wraps to its content
            (~804px) and the nested card Row can't expand — leaving a dead zone
            to the right of the counter tiles. Making it full-width lets the
            inner `flex: 1 1 0` card Cols grow to fill the row. */}
        <Col flex="auto" style={{ position: 'static', minWidth: 0 }}>
          {!isFromCM && (
            <div className={style.breadcrumb}>
              <BreadCrumb
                crumbs={[
                  {
                    label: LANDING_FROM,
                    linkTo: RETURN_TO_PATH
                  },
                  { label: LANDED_IN }
                ]}
              />
            </div>
          )}

          <div className={style.pageContentHeader}>
            <SmartAssessmentTopPanel
              isPrevention={isPrevention}
              alertHeader="Smart Assessment view"
              disableSelect={disableSelectBox}
              isFromCM={isFromCM}
              alertMetaSuffix={alertMetaSuffix}
              alertLevels={alertLevels}
              trmActionsData={trmActionsData}
              {...{ onChangeAlertQuality, alertDetails }}
            />
          </div>
        </Col>
      </Row>
    </div>
  );
};

PageHeader.propTypes = {
  settings: PropTypes.object,
  alertId: PropTypes.string.isRequired,
  isEmbedded: PropTypes.bool,
  isFromCM: PropTypes.bool,
  alertMetaSuffix: PropTypes.element,
  alertLevels: PropTypes.array,
  trmActionsData: PropTypes.array,
  fetchTypologiesActions: PropTypes.func
};

const mapStateToProps = (state) => {
  const {
    alertDetails = {},
    updateUnifiedAlertStatus = {},
    alertLevelConfigs,
    commonTypologyAction
  } = state.amlsCommon;
  return {
    alertDetails,
    updateUnifiedAlertStatus,
    alertLevels: alertLevelConfigs?.data,
    trmActionsData: commonTypologyAction?.data
  };
};

const mapDispatchToProps = (dispatch) => ({
  fetchAlertDetails: (alertId) =>
    dispatch(getAMLSCommonAlertDetails({ alertId })),
  updateUnifiedAlert: (payload) =>
    dispatch(putAMLSCommonAlertPartyUpdate(payload)),
  fetchTypologiesActions: () => dispatch(fetchTypologiesActions())
});

export default connect(mapStateToProps, mapDispatchToProps)(PageHeader);
